import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBSC7LhNVD2ohN-ZqrKs1uTnBiAvltc5U",
  authDomain: "aether-sports.firebaseapp.com",
  projectId: "aether-sports",
  storageBucket: "aether-sports.firebasestorage.app",
  messagingSenderId: "569993351295",
  appId: "1:569993351295:web:cd84a5e8b3680f9092af4a",
  measurementId: "G-QB7CS2VNES"
};



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { auth, db, analytics };
